<template>
    <div
        class="modal fade"
        id="monsterTypeCompendiumModal"
        tabindex="-1"
        aria-hidden="true"
        ref="modal"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h4 class="modal-title">
                        {{
                            mode === "add"
                                ? "Add Monster Type"
                                : "Edit Monster Type"
                        }}
                    </h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                    ></button>
                </div>

                <div class="modal-body">
                    <!-- Edit: pick existing -->
                    <div v-if="mode === 'edit'" class="input-group mb-3">
                        <span class="input-group-text">Select Monster Type</span>
                        <select
                            v-model="selectedName"
                            @change="loadMonsterType"
                            class="form-select"
                        >
                            <option disabled value="">Select...</option>
                            <option
                                v-for="(value, key) in sortedMonsterTypes"
                                :key="key"
                                :value="key"
                            >
                                {{ key }}
                            </option>
                        </select>
                    </div>

                    <!-- Monster type name -->
                    <div class="input-group mb-3">
                        <span class="input-group-text">Name</span>
                        <input v-model="monsterTypeName" class="form-control" />
                    </div>

                    <!-- Archetype descriptions -->
                    <div
                        v-for="arch in archetypes"
                        :key="arch"
                        class="input-group mb-3"
                    >
                        <span class="input-group-text text-capitalize" style="min-width: 120px">
                            {{ arch }}
                        </span>
                        <textarea
                            v-model="monsterType[arch]"
                            class="form-control"
                            rows="2"
                        ></textarea>
                    </div>
                </div>

                <p class="px-3">
                    <strong>
                        Note: These changes won't affect any monsters already
                        added. Remove & re-add them to apply changes.
                    </strong>
                </p>

                <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal">
                        <font-awesome-icon icon="multiply" class="me-1" /> Close
                    </button>
                    <button
                        v-if="mode === 'edit'"
                        class="btn btn-danger me-1"
                        @click="deleteMonsterType"
                    >
                        <font-awesome-icon icon="trash-alt" class="me-1" />
                        Delete
                    </button>
                    <button class="btn btn-primary" @click="saveMonsterType">
                        <font-awesome-icon icon="save" class="me-1" /> Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRosterStore } from "@/stores/index";

export default {
    name: "MonsterTypeCompendiumModal",
    props: { mode: { type: String, default: "add" } },
    data() {
        return {
            store: useRosterStore(),
            selectedName: "",
            monsterTypeName: "",
            archetypes: ["grit", "wit", "smarts", "heart", "luck", "strange"],
            monsterType: {
                grit: "",
                wit: "",
                smarts: "",
                heart: "",
                luck: "",
                strange: "",
            },
        };
    },
    computed: {
        sortedMonsterTypes() {
            return Object.keys(this.store.monsterTypes)
                .sort((a, b) => a.localeCompare(b))
                .reduce((acc, key) => {
                    acc[key] = this.store.monsterTypes[key];
                    return acc;
                }, {});
        },
    },
    mounted() {
        this.$refs.modal.addEventListener("show.bs.modal", () => {
            this.resetForm();
        });
    },
    methods: {
        resetForm() {
            this.selectedName = "";
            this.monsterTypeName = "";
            this.monsterType = {
                grit: "",
                wit: "",
                smarts: "",
                heart: "",
                luck: "",
                strange: "",
            };
        },
        loadMonsterType() {
            const found = this.store.monsterTypes[this.selectedName];
            if (found) {
                this.monsterTypeName = this.selectedName;
                this.monsterType = JSON.parse(JSON.stringify(found));
            }
        },
        saveMonsterType() {
            const name = this.monsterTypeName.trim();
            if (!name) {
                alert("Monster type must have a name!");
                return;
            }

            if (this.mode === "add") {
                if (this.store.monsterTypes[name]) {
                    alert("That monster type already exists!");
                    return;
                }
                this.store.monsterTypes[name] = JSON.parse(
                    JSON.stringify(this.monsterType)
                );
                alert(`Added monster type "${name}"`);
            } else {
                if (!this.selectedName) {
                    alert("Select a monster type to update!");
                    return;
                }
                // If the name changed, handle rename
                if (name !== this.selectedName) {
                    delete this.store.monsterTypes[this.selectedName];
                }
                this.store.monsterTypes[name] = JSON.parse(
                    JSON.stringify(this.monsterType)
                );
                alert(`Updated monster type "${name}"`);
            }

            this.resetForm();
        },
        deleteMonsterType() {
            if (!this.selectedName) return;
            if (confirm(`Delete monster type "${this.selectedName}"?`)) {
                delete this.store.monsterTypes[this.selectedName];
                alert(`Deleted monster type "${this.selectedName}"`);
                this.resetForm();
            }
        },
    },
};
</script>

